/** App-facing parse/validate: binds the scope's config field index to the pipeline. */
import type { SearchTableScope } from '@aibees/elephant/store/search-params-store';
import type { SearchBrowseParams } from '@aibees/elephant/types';
import { buildFieldTypeIndex } from './field-index';
import { parseParams, validateParams } from './pipeline';

export function validateReadable(
  scope: SearchTableScope,
  json: unknown
): string[] {
  return validateParams(json, buildFieldTypeIndex(scope));
}

export function readableToParams(
  scope: SearchTableScope,
  json: Record<string, unknown>
): Partial<SearchBrowseParams> {
  return parseParams(json);
}
